import React, { useState } from "react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import listPlugin from "@fullcalendar/list";
import interaction from "@fullcalendar/interaction";
import bootstrapPlugin from "@fullcalendar/bootstrap5";
import { Popover, PopoverHeader } from "reactstrap";
import FullCalendar from "@fullcalendar/react";

const EventView = (event) => {
  const [mouseEnter, setMouseEnter] = useState(false);
  const { title, publicId } = event.event.event._def;
  const awayReason = event.event.event.extendedProps?.awayReason;
  return (
    <React.Fragment>
      <style>
        {`
          .custom-event-content {
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            max-width: 100% !important;
            font-size: 14px !important;
          }
          .custom-event-content .fc-event-title {
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            max-width: 100% !important;
          }
        `}
      </style>
      <div
        className="custom-event-content"
        id={publicId}
        onMouseEnter={() => setMouseEnter(true)}
        onMouseLeave={() => setMouseEnter(false)}
        dangerouslySetInnerHTML={{ __html: title }}
      />
      <Popover placement="bottom" isOpen={mouseEnter} target={publicId}>
        <PopoverHeader>
          {awayReason ? (
            awayReason
          ) : (
            <span className="custom-event-content" dangerouslySetInnerHTML={{ __html: title }} />
          )}
        </PopoverHeader>
      </Popover>
    </React.Fragment>
  );
};

const CalenderApp = ({ events, onEvent, onAdd, onDateChange, editable = false, eventEditable }) => {
  const handleEventClick = (info) => {
    onEvent(info.event);
  };

  return (
    <React.Fragment>
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, listPlugin, bootstrapPlugin, interaction]}
        events={events}
        eventClick={(info) => handleEventClick(info)}
        datesSet={(dates) => onDateChange(dates.start, dates.end)}
        initialView="dayGridMonth"
        headerToolbar={{
          left: "title prev,next",
          center: null,
          right: "today dayGridMonth,listMonth",
        }}
        themeSystem="bootstrap5"
        height={800}
        contentHeight={780}
        eventContent={(e) => <EventView event={e} />}
        aspectRatio={3}
        editable={editable}
        eventEditable={eventEditable}
        droppable={true}
        dateClick={(info) => onAdd(info)}
        backgroundColor="#1a7dff"
      />
    </React.Fragment>
  );
};

export default CalenderApp;
